import React from 'react';
import { Reveal } from './Reveal';
type Bonus = {
  alt: string;
  image: string;
};
const bonuses: Bonus[] = [{
  alt: 'Bonus 01 — Pre-Session Preparation & Grounding Rituals (value $15, included free)',
  image: 'https://cdn.magicpatterns.com/uploads/bh5Ey5mSSMF7LYmctgyzad/ChatGPT_Image_16_sept_2026,_10_11_01_p.m..png'
}, {
  alt: 'Bonus 02 — Astrological Foundations for Tarot Readers (value $15, included free)',
  image: 'https://cdn.magicpatterns.com/uploads/uYLi1uA16qxsXqDCJ9VGs1/ChatGPT_Image_16_sept_2026,_10_11_11_p.m..png'
}, {
  alt: 'Bonus 03 — Inner Frequency & Resonance Mastery (value $15, included free)',
  image: 'https://cdn.magicpatterns.com/uploads/eJmLxNWMMZZaK1PidDnJWB/ChatGPT_Image_16_sept_2026,_10_11_18_p.m..png'
}, {
  alt: 'Bonus 04 — Energetic Protection & Boundary Mastery (value $15, included free)',
  image: 'https://cdn.magicpatterns.com/uploads/8WdGET3ddfm3Zi4hD9wcP4/ChatGPT_Image_16_sept_2026,_10_11_26_p.m..png'
}, {
  alt: 'Bonus 05 — Professional Ethics & Scope of Practice (value $15, included free)',
  image: 'https://cdn.magicpatterns.com/uploads/7174icyUFgbgyKsmw2aYpz/ChatGPT_Image_16_sept_2026,_10_11_33_p.m..png'
}];
export function Bonuses() {
  return <section className="w-full bg-surface px-4 py-20 sm:py-24" data-id="element-19" data-mp="3n5erqeiqbp9d">
      <div className="mx-auto max-w-6xl" data-id="element-20" data-mp="3n5y6xngzvzjp">
        <Reveal className="text-center" data-id="element-21" data-mp="2zf29a9puya4j">
          <h2 className="font-serif text-4xl leading-tight text-navy sm:text-5xl" data-id="element-22" data-mp="2zg3wfck5en2m">
            🎁 5 Exclusive <span className="text-amber" data-id="element-23" data-mp="2ui25k5ghdjgl">Bonus Resource Kits</span>
          </h2>
          <p className="mt-4 text-sm text-slate sm:text-base" data-id="element-24" data-mp="38hbh2rtqrpe8">Included FREE with your purchase</p>
        </Reveal>
        <div className="mt-10 flex flex-col items-center gap-3 sm:gap-4" data-id="element-25" data-mp="33fm77fi99hrq">
          {bonuses.map((bonus, index) => <Reveal key={bonus.image} delay={index * 0.04} className="w-full max-w-4xl" data-id="element-26" data-mp="ns4bqd4poebe" data-mpi={index}>
              <img src={bonus.image} alt={bonus.alt} width={1536} height={1024} loading="lazy" className="block h-auto w-full rounded-2xl object-contain" data-id="element-27" data-mp="iqor2m6g49tj" />
            </Reveal>)}
        </div>
      </div>
    </section>;
}